import { FC } from 'react';
import { withApplicationLayout } from '../hocs/withApplicationLayout';
import { PageNotFound } from '../modules/PageNotFound/PageNotFound';

const Custom404: FC = () => {
  return <PageNotFound />;
};

export default withApplicationLayout()(Custom404, { withFooter: true });
